import React from 'react';
import { trackEvent, EventCategory, ButtonType } from '@lendi/analytics';

export const trackFooterNavigation = ({ text, type = 'Link' }: { text: string; type?: string }): void => {
  const linkType = type === 'Logo' ? `Logo ${ButtonType.ICON}` : ButtonType.LINK;
  trackEvent({
    text,
    event_name: 'Link Clicked',
    linkType,
    category: EventCategory.FOOTER,
  });
};

export interface FooterAnalyticsProps {
  analyticsForFooter: (text: string, type?: string) => void;
}

export const FooterAnalyticsContext = React.createContext<FooterAnalyticsProps>({
  analyticsForFooter: () => {
    return;
  },
});

export const FooterAnalyticsProvider = FooterAnalyticsContext.Provider;
